module.exports = __webpack_public_path__ + "static/media/threeDots.d442906e.svg";